import type { DetectOptions, DetectionResult, ExecFileSync } from './types';
import { execFileSync as nodeExecFileSync } from 'node:child_process';
import { normalizeIdentifier } from './normalize';

const runShellTerm = (run: ExecFileSync): string => {
  return run('sh', ['-c', 'printf %s "$TERM"'], {
    encoding: 'utf8',
    timeout: 1000,
    stdio: ['ignore', 'pipe', 'ignore']
  }) as string;
};

export const detectFromShellResult = (
  options: DetectOptions = {}
): DetectionResult | null => {
  const env = options.env ?? process.env;
  const platform = options.platform ?? process.platform;

  try {
    if (platform === 'win32') {
      if (env.WT_SESSION) {
        return {
          terminal: 'windows_terminal',
          source: 'shell'
        };
      }

      const shell = env.COMSPEC?.toLowerCase() || '';
      if (/powershell/i.test(shell)) {
        return {
          terminal: 'powershell',
          source: 'shell'
        };
      }

      if (/pwsh/i.test(shell)) {
        return {
          terminal: 'powershell',
          source: 'shell'
        };
      }

      if (/cmd\.exe/i.test(shell)) {
        return {
          terminal: 'cmd',
          source: 'shell'
        };
      }

      if (/wt\.exe/i.test(shell)) {
        return {
          terminal: 'windows_terminal',
          source: 'shell'
        };
      }

      if (/conhost\.exe/i.test(shell)) {
        return {
          terminal: 'conhost',
          source: 'shell'
        };
      }

      return {
        terminal: 'windows_cmd',
        source: 'shell'
      };
    }

    const run = options.execFileSync ?? nodeExecFileSync;
    const terminal = normalizeIdentifier(runShellTerm(run));

    if (!terminal) {
      return null;
    }

    if (!options.preferOuter) {
      if (terminal.startsWith('tmux')) {
        return {
          terminal: 'tmux',
          source: 'shell'
        };
      }

      if (terminal.startsWith('screen')) {
        return {
          terminal: 'screen',
          source: 'shell'
        };
      }
    }

    return {
      terminal,
      source: 'shell'
    };
  } catch {
    return null;
  }
};

export const detectFromShell = (options: DetectOptions = {}): string | null => {
  return detectFromShellResult(options)?.terminal ?? null;
};
